import i18n from '@/i18n';

export const deliveryItems: any = {
  'No sample shipment': {
    notes: [
      i18n.t('education.delivery.no_sample.note1', {
        defaultValue:
          'Please ensure your content is uploaded and the final link submitted on Aha Creator within <b>7 days of brand confirmation</b>'
      }),
      i18n.t('education.delivery.no_sample.note2', {
        defaultValue:
          'To help us track performance and secure your earnings, please make sure to include the promotional link in your content as specified in the CTA requirements'
      })
    ]
  },
  'With sample shipment': {
    notes: [
      i18n.t('education.delivery.with_sample.note1', {
        defaultValue:
          'Please ensure your content is uploaded and the final link submitted on Aha Creator within <b>7 days of product arrival</b>'
      }),
      i18n.t('education.delivery.with_sample.note2', {
        defaultValue:
          'To help us track performance and secure your earnings, please make sure to include the promotional link in your content as specified in the CTA requirements'
      })
    ]
  },
  'Dedicated video': {
    img: '/delivery-youtube1-education.png',
    notes: [
      i18n.t('education.delivery.dedicated_video.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, <b>please do not start production</b> until the collaboration is confirmed by the brand.'
      }),
      i18n.t('education.delivery.dedicated_video.note2', {
        defaultValue:
          'For YouTube videos, you can choose to submit a script or not before submitting video content. For other platforms, script is not required.'
      }),
      i18n.t('education.delivery.dedicated_video.note3', {
        defaultValue:
          'The brand may request up to 4 times revision. For each revision you have 7 days to submit your revised content.'
      }),
      i18n.t('education.delivery.dedicated_video.note4', {
        defaultValue:
          'Any specific <b>requirements from the brand</b> are shown in the "Requirement" section. Please make sure to review them before producing content'
      })
    ]
  },
  'Integrated video': {
    img: '/delivery-youtube2-education.png',
    notes: [
      i18n.t('education.delivery.integrated_video.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, <b>please do not start production</b> until the collaboration is confirmed by the brand'
      }),
      i18n.t('education.delivery.integrated_video.note2', {
        defaultValue:
          'For YouTube videos, you can choose to submit a script or not before submitting video content.'
      }),
      i18n.t('education.delivery.integrated_video.note3', {
        defaultValue:
          'The brand may request up to 4 times revision. For each revision you have 5 days to submit your revised content.'
      }),
      i18n.t('education.delivery.integrated_video.note4', {
        defaultValue:
          'Any specific <b>requirements from the brand</b> are shown in the "Requirement" section. Please make sure to review them before producing content'
      })
    ]
  },
  tiktok: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-vertical-new.png',
    notes: [
      i18n.t('education.delivery.tiktok.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, <b>please do not start production</b> until the collaboration is confirmed by the brand'
      }),
      i18n.t('education.delivery.tiktok.note2', {
        defaultValue:
          'For YouTube videos, you can choose to submit a script or not before submitting video content.'
      }),
      i18n.t('education.delivery.tiktok.note3', {
        defaultValue:
          'The brand may request up to 4 times revision. For each revision you have 5 days to submit your revised content.'
      }),
      i18n.t('education.delivery.tiktok.note4', {
        defaultValue:
          'Any specific <b>requirements from the brand</b> are shown in the "Requirement" section. Please make sure to review them before producing content'
      })
    ]
  },
  twitter: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-vertical-new.png',
    notes: [
      i18n.t('education.delivery.twitter.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, <b>please do not start production</b> until the collaboration is confirmed by the brand'
      }),
      i18n.t('education.delivery.twitter.note2', {
        defaultValue:
          'For YouTube videos, you can choose to submit a script or not before submitting video content.'
      }),
      i18n.t('education.delivery.twitter.note3', {
        defaultValue:
          'The brand may request up to 4 times revision. For each revision you have 5 days to submit your revised content.'
      }),
      i18n.t('education.delivery.twitter.note4', {
        defaultValue:
          'Any specific <b>requirements from the brand</b> are shown in the "Requirement" section. Please make sure to review them before producing content'
      })
    ]
  },
  instagram: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-vertical-new.png',
    notes: [
      i18n.t('education.delivery.instagram.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, <b>please do not start production</b> until the collaboration is confirmed by the brand'
      }),
      i18n.t('education.delivery.instagram.note2', {
        defaultValue:
          'For YouTube videos, you can choose to submit a script or not before submitting video content.'
      }),
      i18n.t('education.delivery.instagram.note3', {
        defaultValue:
          'The brand may request up to 4 times revision. For each revision you have 5 days to submit your revised content.'
      }),
      i18n.t('education.delivery.instagram.note4', {
        defaultValue:
          'Any specific <b>requirements from the brand</b> are shown in the "Requirement" section. Please make sure to review them before producing content'
      })
    ]
  },
  linkedin: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-integrated-order-vertical-new.png',
    notes: [
      i18n.t('education.delivery.linkedin.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, <b>please do not start production</b> until the collaboration is confirmed by the brand'
      }),
      i18n.t('education.delivery.linkedin.note2', {
        defaultValue:
          'For YouTube videos, you can choose to submit a script or not before submitting video content.'
      }),
      i18n.t('education.delivery.linkedin.note3', {
        defaultValue:
          'The brand may request up to 4 times revision. For each revision you have 5 days to submit your revised content.'
      }),
      i18n.t('education.delivery.linkedin.note4', {
        defaultValue:
          'Any specific <b>requirements from the brand</b> are shown in the "Requirement" section. Please make sure to review them before producing content'
      })
    ]
  }
};

export const ctaItems: any = {
  youtube: {
    img: '/cta-youtube.png',
    notes: [
      i18n.t('education.cta.youtube.note1', {
        defaultValue:
          '<b>Engaging Video Placement:</b> Place the CTA at the most engaging point in your video to capture viewer interest effectively'
      }),
      i18n.t('education.cta.youtube.note2', {
        defaultValue:
          '<b>Description:</b> Use a strong call-to-action for promotion at the beginning of description. Ensure CTA and link are visible even when collapsed. '
      }),
      i18n.t('education.cta.youtube.note3', {
        defaultValue:
          '<b>Pinned Comment:</b> Post the CTA and promotional link as the first pinned comment to ensure it remains visible and accessible.'
      }),
      i18n.t('education.cta.youtube.note4', {
        defaultValue:
          '<b>Aha-Provided Link:</b> Use the promotional link provided by Aha, not the official website link or a redirected link.'
      }),
      i18n.t('education.cta.youtube.note5', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  tiktok: {
    img: '/cta-tiktok.png',
    notes: [
      i18n.t('education.cta.tiktok.note1', {
        defaultValue: `<b>Ending CTA:</b> Prompt viewers in speech and with caption at the end of the video. E.g., "Tap the link in bio for more info!" `
      }),
      i18n.t('education.cta.tiktok.note2', {
        defaultValue: `<b>Caption:</b> Use a concise and engaging caption with a strong call-to-action. E.g., : "Check the link in bio now! 🌟"`
      }),
      i18n.t('education.cta.tiktok.note3', {
        defaultValue: `<b>Link in bio:</b> The link should be placed at the top of bio. If you're using Linktree, position your promotional link directly above Linktree or add it as the first link within Linktree to ensure it's easily accessible.`
      }),
      i18n.t('education.cta.tiktok.note4', {
        defaultValue: `<b>Aha-Provided Link:</b> Use the promotional link provided by Aha, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.tiktok.note5', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  twitter: {
    img: '/cta-twitter.png',
    notes: [
      i18n.t('education.cta.twitter.note1', {
        defaultValue: `<b>Ending CTA:</b> If you are posting a video, prompt viewers in speech and with caption at the end of the video. E.g., "Visit the link in our tweet for more info!" `
      }),
      i18n.t('education.cta.twitter.note2', {
        defaultValue: `<b>Caption:</b> Post with a strong CTA in the caption, like: "Check out more: {link}🌟"`
      }),
      i18n.t('education.cta.twitter.note3', {
        defaultValue: `<b>Aha-Provided Link:</b> Use the promotional link provided by Aha, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.twitter.note4', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  instagram: {
    img: '/cta-instagram.png',
    notes: [
      i18n.t('education.cta.instagram.note1', {
        defaultValue: `<b>Ending CTA:</b> If you are posting a Reel, clearly state, "Check the link in bio!" depending on the features available.`
      }),
      i18n.t('education.cta.instagram.note2', {
        defaultValue: `<b>Caption:</b> Use a concise and engaging caption with a strong call-to-action. E.g., : "Check the link in bio now! 🌟"`
      }),
      i18n.t('education.cta.instagram.note3', {
        defaultValue: `<b>Link in bio:</b> The link should be placed at the top of bio. If you're using Linktree, position your promotional link directly above Linktree or add it as the first link within Linktree to ensure it's easily accessible.`
      }),
      i18n.t('education.cta.instagram.note4', {
        defaultValue: `<b>Aha-Provided Link:</b> Use the promotional link provided by Aha, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.instagram.note5', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  linkedin: {
    img: '/cta-linkedin.png',
    notes: [
      i18n.t('education.cta.linkedin.note1', {
        defaultValue: `<b>Ending CTA:</b> If you are posting with a video, integrate a clear verbal or text-based CTA within the video, such as "Visit the link in my post for more info."`
      }),
      i18n.t('education.cta.linkedin.note2', {
        defaultValue: `<b>Caption:</b> Post with a strong CTA in the caption, like: "Check out more: {link}🌟"`
      }),
      i18n.t('education.cta.linkedin.note3', {
        defaultValue: `<b>Aha-Provided Link:</b> Use the promotional link provided by Aha, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.linkedin.note4', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  }
};

export const policyItems: any = [
  {
    title: i18n.t('education.policy.organic_views.title', {
      defaultValue: '100% organic views '
    }),
    des: i18n.t('education.policy.organic_views.desc', {
      defaultValue:
        'A full refund can be requested if fraudulent views are detected'
    })
  },
  {
    title: i18n.t('education.policy.off_platform.title', {
      defaultValue: 'No off-platform transactions'
    }),
    des: i18n.t('education.policy.off_platform.desc', {
      defaultValue:
        'Engaging and transacting with brands outside of Aha Creator is strictly prohibited'
    })
  },
  {
    title: i18n.t('education.policy.late_submission.title', {
      defaultValue: 'Late submisison'
    }),
    des: i18n.t('education.policy.late_submission.desc', {
      defaultValue:
        'A full refund may be requested by brand if submissions are late'
    })
  },
  {
    title: i18n.t('education.policy.quality.title', {
      defaultValue: 'Quality content'
    }),
    des: i18n.t('education.policy.quality.desc', {
      defaultValue:
        'Content should provide value to the audience, and fully AI-generated content is not permitted'
    })
  },
  {
    title: i18n.t('education.policy.cancellation.title', {
      defaultValue: 'Deal cancellation  for your own reason'
    }),
    des: i18n.t('education.policy.cancellation.desc', {
      defaultValue:
        "If you cancel a deal for your own reasons, you're required to cover any losses incurred by the brand, e.g. product and shipping fees"
    })
  },
  {
    title: i18n.t('education.policy.agreement.title', {
      defaultValue: 'Creator agreement'
    }),
    des: i18n.t('education.policy.agreement.desc', {
      defaultValue:
        'To ensure your rights are protected, please carefully read the '
    })
  }
];

export const items = [
  i18n.t('education.tabs.delivery', { defaultValue: 'Delivery timeline' }),
  i18n.t('education.tabs.cta', { defaultValue: 'CTA requirements' }),
  i18n.t('education.tabs.policy', { defaultValue: 'Platform policy' }),
  i18n.t('education.tabs.payment', { defaultValue: 'Payment' })
];

export const trendDeliveryItems: any = {
  imgUrl:
    'https://website-resource.ahaglobal.io/ads-platform/ads-guide-trend.png',
  verticalImgUrl:
    'https://website-resource.ahaglobal.io/ads-platform/ads-guide-trend.png-vertical',
  notes: [
    "To ensure your creative work is properly compensated, <span class='text-text-color-primary text-base font-bold font-['Inter'] leading-7'> please do not start production</span> until the collaboration is confirmed by the brand.",
    'The brand may request up to 4 times revision. For each revision you have 1 day to submit your revised content.'
  ]
};
